import ScriptsEmbed from './ScriptsEmbed.component';
export default ScriptsEmbed;